import { tradingSummary } from '@/utils/tradingSummary';
import { journalEntries } from '@/utils/journalFeed';
import StepSection from './StepSection';

const trade = journalEntries[0];
const realized = Number(trade.result.replace(/[+,]/g, ''));

const fields = [
  { index: '01', label: 'Entry Price', detail: 'Position opened', value: trade.entry },
  { index: '02', label: 'Exit Fill', detail: 'Position closed', value: trade.exit },
  { index: '03', label: 'Volume', detail: 'Fixed per the risk model', value: trade.volume },
  {
    index: '04',
    label: 'Exit Reason',
    detail: 'Rule-based exit · no manual close',
    value: 'PROTECTIVE STOP',
  },
];

function StepClose() {
  return (
    <StepSection
      id="step-08"
      index="08"
      stage="execute"
      title="Close The Trade"
      subtitle="Every position eventually becomes a recorded result."
      body="Both winning and losing trades are part of the recorded history, and neither side is filtered out of the record."
      reverse
    >
      <div className="rounded-lg border border-background-300 bg-background-50 overflow-hidden">
        <div className="flex items-center justify-between px-4 md:px-5 h-11 border-b border-background-200 bg-background-100">
          <span className="flex items-center gap-2 text-[11px] font-data tracking-widest text-foreground-700">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 breathe"></span>
            POSITION CLOSED · REALIZED
          </span>
          <span className="text-[10px] font-data tracking-widest text-foreground-400">LOGGED</span>
        </div>

        <div className="flex items-end justify-between px-4 md:px-5 pt-4 pb-3">
          <div>
            <p className="text-[10px] font-data tracking-[0.22em] text-foreground-400">
              REALIZED P&amp;L
            </p>
            <p
              className={`mt-1.5 font-data text-[30px] md:text-[34px] font-semibold leading-none ${
                realized >= 0 ? 'text-profit-600' : 'text-loss-600'
              }`}
            >
              {trade.result}
            </p>
          </div>
          <div className="text-right">
            <p className="text-[10px] font-data tracking-[0.22em] text-foreground-400">
              EXIT FILL
            </p>
            <p className="mt-1.5 font-data text-[15px] font-semibold leading-none text-foreground-950">
              {trade.exit}
            </p>
          </div>
        </div>

        <div className="divide-y divide-background-200 border-t border-background-200">
          {fields.map((row) => (
            <div key={row.index} className="flex items-center gap-3 px-4 md:px-5 py-3.5">
              <span className="w-5 shrink-0 font-data text-[11px] text-foreground-400">
                {row.index}
              </span>
              <div className="min-w-0 flex-1">
                <p className="text-[13px] font-semibold text-foreground-900 truncate">{row.label}</p>
                <p className="text-[11px] text-foreground-500 truncate">{row.detail}</p>
              </div>
              <span className="shrink-0 font-data text-[13px] font-semibold text-foreground-950">
                {row.value}
              </span>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 gap-px bg-background-200 border-t border-background-200">
          <div className="bg-background-50 px-4 md:px-5 py-3.5">
            <p className="text-[10px] font-data tracking-widest text-foreground-500">
              BEST RECORDED
            </p>
            <p className="mt-1.5 font-data text-[16px] font-semibold text-profit-600">
              {tradingSummary.bestTrade}
            </p>
          </div>
          <div className="bg-background-50 px-4 md:px-5 py-3.5">
            <p className="text-[10px] font-data tracking-widest text-foreground-500">
              WORST RECORDED
            </p>
            <p className="mt-1.5 font-data text-[16px] font-semibold text-loss-600">
              {tradingSummary.worstTrade}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between border-t border-background-200 bg-background-100 px-4 md:px-5 py-3">
          <span className="font-data text-[10px] tracking-widest text-foreground-400">
            {trade.instrument} · {trade.date}
          </span>
          <span className="font-data text-[10px] tracking-widest text-foreground-500">
            WINS AND LOSSES BOTH RECORDED
          </span>
        </div>
      </div>
    </StepSection>
  );
}

export default StepClose;